import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVercel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVercel"><Path d="M11.8632 2.17999L22.7264 20.9958H1L11.8632 2.17999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVercel;
